export function isArrayLike(x: unknown): x is ArrayLike<any> {
    if (x != null && typeof x === 'object') {
        const y = x as any;
        return (
            typeof y.length === 'number' &&
            Number.isSafeInteger(y.length) &&
            y.length >= 0
        );
    }
    return false;
}

export const hasOwnProperty = (obj: any, prop: string) =>
    Object.prototype.hasOwnProperty.call(obj, prop);
